import React from 'react';

// 입력칸 바로 아래 빨간 한 줄. id 는 useFieldErrors().fieldProps 의 aria-describedby 와 짝이다.
export default function FieldError({ field, errors }) {
    const message = errors && errors[field];
    if (!message) return null;
    return <p className="sds-field-error" id={`${field}-error`} role="alert">{message}</p>;
}
